var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01. General / GPS Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.88965 9.1112L16.8258 3.82507L11.5397 17.7612L9.13689 11.514L2.88965 9.1112Z",
    fill: "black"
  }))));
};
export default SvgMap;